var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('e-dialog',{attrs:{"dialog-title":"提示","center-dialog-visible":_vm.showSubSupplierTip,"popup-width":"400px","closeBtn":true,"buttonTip":"前往"},on:{"resetPopupData":_vm.handleClose,"submitPopupData":_vm.submitPopupData}},[_c('div',[_vm._v("该订单供应商不在分供商清单中，请先维护供应商清单，石化订单方可关联此原材料订单，是否前往“运营中心-溯源管理-分供商维护”维护供应商清单？")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }